import { Link } from "react-router-dom";
import { portalArticles } from "@/mocks/articles";

export default function PortalSection() {
  return (
    <section className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-10">
          <button className="whitespace-nowrap self-start px-5 py-2 rounded-full border border-background-50/30 text-background-50 text-sm font-medium cursor-pointer hover:bg-background-50/10 transition-colors duration-200">
            每日大赛不打烊
          </button>

          <h2 className="lg:ml-auto lg:text-right text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-background-50 leading-tight lg:max-w-2xl">
            24小时黑料传送门
          </h2>
        </div>

        <div className="flex gap-4 overflow-x-auto scrollbar-hide" style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}>
          {portalArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="flex-shrink-0 w-64 md:w-72 cursor-pointer group"
            >
              <div className="bg-background-100 rounded-xl overflow-hidden">
                <div className="h-48 md:h-56 overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="bg-foreground-950 p-4">
                  <h3 className="text-sm font-semibold text-background-50 line-clamp-2 leading-snug mb-2 group-hover:text-accent-400 transition-colors duration-200">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-3 text-xs text-foreground-300">
                    <span>{article.publishDate}</span>
                    <span>来源：{article.author}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}